<template>
  <v-container fluid>
    <v-row
      align="stretch"
      justify="center"
    >
      <v-col
        class="mt-3"
        cols="12"
        sm="6"
        md="4"
        data-aos="fade-up"
        v-for="(profile, index) in section.profiles"
        :key="index"
      >
        <v-card
          color="transparent"
          flat
        >
          <profile
            :height="profileHeight"
            :image="profile.image"
            :name="profile.name"
          >
            <template v-slot:description>
              <v-card flat v-html="profile.description"></v-card>
            </template>
          </profile>
        </v-card>
      </v-col>
    </v-row>

    <template v-if="editable">
      <v-overlay
        absolute
        opacity="0.2"
        :value="editable"
      >
        <v-row align="start" justify="center" class="mb-1">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                fab
                @click="emitAction('profiles')"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
            </template>
            <span>Edit</span>
          </v-tooltip>
        </v-row>
        <v-row align="start" justify="center">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                fab
                small
                @click="emitAction('moveUp')"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>mdi-arrow-up</v-icon>
              </v-btn>
            </template>
            <span>Move Up</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                fab
                small
                @click="emitAction('moveDown')"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>mdi-arrow-down</v-icon>
              </v-btn>
            </template>
            <span>Move Down</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                fab
                small
                @click="emitAction('delete')"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </template>
            <span>Delete</span>
          </v-tooltip>
        </v-row>

      </v-overlay>
    </template>
  </v-container>
</template>

<script>
import Profile from '@/components/Profile'
import {
  VBtn,
  VCard,
  VCol,
  VContainer,
  VIcon,
  VOverlay,
  VRow,
  VTooltip,
} from 'vuetify/lib'

export default {
  components: {
    Profile,
    VBtn,
    VCard,
    VCol,
    VContainer,
    VIcon,
    VOverlay,
    VRow,
    VTooltip,
  },
  computed: {
    profileHeight() {
      switch (this.$vuetify.breakpoint.name) {
        case 'sm': return '410'
        case 'md': return '350'
        case 'lg': return '300'
      }
      return undefined
    }
  },
  data: () => ({
    profiles: []
  }),
  methods: {
    emitAction(action) {
      this.$emit('action', {
        action,
        index: this.index,
        section: this.section,
      })
    }
  },
  props: {
    editable: {
      default: false,
      type: Boolean,
    },
    index: {
      default: null,
      type: Number,
    },
    section: {
      default() {
        return {}
      },
      type: Object,
    }
  }
}
</script>
